import { useCallback as e, useState as t } from "react";
import { css as n, keyframes as r, styled as i } from "styled-components";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { ImageOff as s } from "lucide-react";
//#region src/components/Image/Image.tsx
var c = r`
    from { transform: translateX(-100%); }
    to   { transform: translateX(100%); }
`, l = r`
    from { opacity: 0; }
    to   { opacity: 1; }
`, u = {
	none: "0",
	sm: "4px",
	md: "8px",
	lg: "12px",
	xl: "16px",
	full: "9999px"
}, d = i.div`
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: ${({ $radius: e }) => u[e]};
    background: ${({ theme: e }) => e.colors.muted};
    width: ${({ $width: e }) => e ?? "100%"};
    ${({ $height: e }) => e && n`
            height: ${e};
        `}
    ${({ $aspectRatio: e }) => e && n`
            aspect-ratio: ${e};
        `}
    cursor: ${({ $clickable: e }) => e ? "pointer" : "default"};
    flex-shrink: 0;

    ${({ $clickable: e }) => e && n`
            &:hover img {
                transform: scale(1.03);
            }
        `}
`, f = i.img`
    width: 100%;
    height: 100%;
    object-fit: ${({ $fit: e }) => e};
    display: block;
    opacity: ${({ $visible: e }) => e ? 1 : 0};
    ${({ $clickable: e }) => e && n`
            transition: transform 300ms ease;
        `}
    ${({ $fade: e }) => e && n`
            animation: ${l} 200ms ease;
        `}
`, p = i.div`
    position: absolute;
    inset: 0;
    overflow: hidden;
    contain: strict;
    background: ${({ theme: e }) => e.colors.muted};
    pointer-events: none;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
            90deg,
            transparent 25%,
            ${({ theme: e }) => e.colors.accent} 50%,
            transparent 75%
        );
        animation: ${c} 1.4s infinite linear;
    }
`, m = i.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    background: ${({ theme: e }) => e.colors.muted};
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, h = ({ src: n, alt: r, width: i, height: c, aspectRatio: l, fit: u = "cover", radius: h = "none", lazy: g = !0, priority: _ = !1, srcSet: v, sizes: y, fallback: b, skeleton: x = !0, className: S, onClick: C }) => {
	let [w, T] = t(_ ? "loaded" : "loading"), [E, D] = t(!1), O = e((e) => {
		e?.complete && e.currentSrc && T(e.naturalWidth === 0 ? "error" : "loaded");
	}, []), k = (e) => e === void 0 ? void 0 : typeof e == "number" ? `${e}px` : e;
	return /* @__PURE__ */ o(d, {
		$width: k(i),
		$height: k(c),
		$aspectRatio: l,
		$radius: h,
		$clickable: !!C,
		className: S,
		onClick: C,
		children: [
			x && !_ && w === "loading" && /* @__PURE__ */ a(p, { "aria-hidden": "true" }),
			w !== "error" && /* @__PURE__ */ a(f, {
				ref: O,
				src: n,
				srcSet: v,
				sizes: y,
				alt: r,
				$fit: u,
				$visible: w === "loaded",
				$fade: E,
				$clickable: !!C,
				loading: g && !_ ? "lazy" : "eager",
				fetchPriority: _ ? "high" : "auto",
				decoding: "async",
				onLoad: () => {
					w === "loading" && D(!0), T("loaded");
				},
				onError: () => T("error"),
				draggable: !1
			}),
			w === "error" && /* @__PURE__ */ a(m, {
				role: "img",
				"aria-label": r,
				children: b ?? /* @__PURE__ */ a(s, {
					size: 24,
					strokeWidth: 1.5
				})
			})
		]
	});
};
//#endregion
export { h as Image };
